const GET_BANNERS = `
query getBanners($where: JSON, $limit: Int, $offset: Int, $sort: [GetBannersSortItem]){
  banners: getBanners(where: $where, limit: $limit, offset: $offset, sort: $sort){
    id,
    name,
    sizes {
      width
      height
    }
  }
}
`;

export { GET_BANNERS };
